<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Change password</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <div class="flex flex-col gap-4">
        <Input
          v-model="currentPassword"
          type="password"
          label="Current password"
          size="xl"
          :disabled="loading"
          :error="currentPasswordError"
        />
        <Input
          v-model="newPassword"
          type="password"
          label="New password"
          size="xl"
          :disabled="loading"
        />
        <Input
          v-model="confirmPassword"
          type="password"
          label="Confirm new password"
          size="xl"
          :disabled="loading"
          :error="confirmPasswordError"
        />
        <button
          type="button"
          class="self-start text-[14px] text-link"
          :class="{ 'pointer-events-none': loading }"
          @click="handleForgot"
        >
          Forgot password?
        </button>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'

import { useChangePassword } from './useChangePassword'

const { close } = useSheet()

const {
  currentPassword,
  newPassword,
  confirmPassword,
  currentPasswordError,
  confirmPasswordError,
  loading,
  canSave,
  save,
  forgotPassword,
} = useChangePassword()

const handleSave = async () => {
  if (await save()) close()
}

const handleForgot = async () => {
  await forgotPassword()
  close()
}
</script>
